import { getUserInitials } from '@/lib/string/string-utils'
import { cn } from '@/lib/ui/style-helpers'

import { Avatar, type AvatarProps } from './avatar'
import { AvatarFallback } from './avatar-fallback'
import { AvatarImage } from './avatar-image'
import type { AvatarColor } from './types'
import { getColorForName } from './utils'

type StringNameAvatarProps = {
  name: string
  maxLength?: number
  className?: string
  onClick?: () => void
  size?: AvatarProps['size']
  color?: AvatarColor
  type?: 'initials' | 'image'
  imageSrc?: string
}

export const StringNameAvatar = ({
  name,
  maxLength,
  className,
  onClick,
  size = 'small',
  color,
  type = 'initials',
  imageSrc,
}: StringNameAvatarProps) => {
  const userInitials = getUserInitials(name, maxLength)
  const resolvedColor: AvatarColor = color ?? getColorForName(name)
  return (
    <Avatar
      size={size}
      color={resolvedColor}
      className={cn('uppercase text-main-foreground-primary', className)}
      onClick={onClick}
    >
      {type === 'image' && imageSrc ? (
        <AvatarImage src={imageSrc} alt={name} />
      ) : (
        <AvatarFallback size={size}>{userInitials}</AvatarFallback>
      )}
    </Avatar>
  )
}
